import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {storeWithHistory} from './store';
import AppRouter, {history} from './pages';
import ApolloClient from 'apollo-boost';
import gql from 'graphql-tag';
import {Query} from '@apollo/react-components';
import {ApolloProvider} from '@apollo/react-common';
import MuiProvider from './providers/MuiProvider';
import {getTokenOrLogin} from './auth';
import './index.css';
import {initializeMetrics} from './metrics';

const store = storeWithHistory(history);

initializeMetrics(history);
//ms
export const minute = 60000;

const client = new ApolloClient({
  uri: `${process.env.REACT_APP_API_ROOT}/graphql`,

  request: async operation => {
    if (process.env.REACT_APP_DISABLE_AD === 'TRUE') {
      return;
    }

    const token = await getTokenOrLogin();
    operation.setContext({
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  },
});

export const GET_ALL_ACTIVE_ALARMS = gql`
  {
    systems {
      id
      downtime
      alarmCategory
      alarms {
        code
        category
        text
        start
      }
    }
  }
`;

ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <MuiProvider>
        <AppRouter />
        <Query
          query={GET_ALL_ACTIVE_ALARMS}
          pollInterval={minute}
          fetchPolicy="network-only"
        >
          {() => null}
        </Query>
      </MuiProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById('root'),
);
